import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import './ProductPage.css';

const ProductPage = () => {
  const [categoriesData, setCategoriesData] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  useEffect(() => {
    fetch('/data/products.json')
      .then((res) => res.json())
      .then((data) => setCategoriesData(data));
  }, []);

  if (!categoriesData) return <p>Loading...</p>;

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
    setSelectedSubcategory(null); // Reset subcategory selection
  };

  const handleSubcategoryClick = (subcategoryId) => {
    setSelectedSubcategory(subcategoryId);
  };

  const goBack = () => {
    if (selectedSubcategory) {
      setSelectedSubcategory(null);
    } else {
      setSelectedCategory(null);
    }
  };

  // Render main categories (Poles, Outdoor)
  const renderCategories = () => (
    <div className="categories">
      {categoriesData.categories.map((category) => (
        <div
          key={category.id}
          className="category"
          onClick={() => handleCategoryClick(category.id)}
        >
          <img src={category.image} alt={category.name} />
          <h2>{category.name}</h2>
        </div>
      ))}
    </div>
  );

  // Render subcategories in a 3-column grid
  const renderSubcategories = () => {
    const category = categoriesData.categories.find(
      (cat) => cat.id === selectedCategory
    );

    return (
      <div>
        <button className="back-button" onClick={goBack}>Back</button>
        {/* <h1>{category.name} Subcategories</h1> */}
        <div className="subcategories">
          {category.subcategories.map((sub) => (
            <div
              key={sub.id}
              className="subcategory"
              onClick={() => handleSubcategoryClick(sub.id)}
            >
              <img src={sub.image} alt={sub.name} />
              <h3>{sub.name}</h3>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render grouped products in the selected subcategory
const renderProducts = () => {
  const category = categoriesData.categories.find(
    (cat) => cat.id === selectedCategory
  );
  const subcategory = category.subcategories.find(
    (sub) => sub.id === selectedSubcategory
  );

  return (
    <div>
      <button className="back-button" onClick={goBack}>Back</button>
      <h1>{subcategory.name} Products</h1>

      {/* If grouped structure exists */}
      {subcategory.groups ? (
        subcategory.groups.map((group) => (
          <div key={group.id}>
            <h2 className="group-title">{group.name}</h2>
            <div className="product-list">
              {group.products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="product-list">
          {subcategory.products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};


  return (
    <div className="product-page">
      {!selectedCategory
        ? renderCategories()
        : !selectedSubcategory
        ? renderSubcategories()
        : renderProducts()}
    </div>
  );
};

export default ProductPage;
